import { render, staticRenderFns } from "./ProjectsMenu.vue?vue&type=template&id=5ec4c50e&scoped=true"
import script from "./ProjectsMenu.vue?vue&type=script&lang=js"
export * from "./ProjectsMenu.vue?vue&type=script&lang=js"
import style0 from "./ProjectsMenu.vue?vue&type=style&index=0&id=5ec4c50e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec4c50e",
  null
  
)

export default component.exports